import { X, ExclamationTriangleFill } from "react-bootstrap-icons";
import { getFileIcon, formatSize, hexToRgba } from "./Utils";
import { ERROR_MESSAGES } from "./Utils";
import "./Upload.css";

const FileRow = ({ file, onRemove }) => {
  const icon = getFileIcon(file.name);
  const hasError = !!file.error;

  return (
    <div className={`upload-file-row${hasError ? " has-error" : ""}`}>
      <span
        className="upload-file-row__type-badge"
        style={{
          color: icon.color,
          background: hexToRgba(icon.color, 0.12),
        }}
      >
        {icon.label}
      </span>

      <div className="upload-file-row__info">
        <div className="upload-file-row__name">{file.name}</div>
        <div className="upload-file-row__size">
          {hasError ? (
            <span className="upload-file-row__error-msg">
              {ERROR_MESSAGES[file.error]}
            </span>
          ) : (
            formatSize(file.size)
          )}
        </div>
      </div>

      {hasError && (
        <ExclamationTriangleFill
          size={13}
          color="#dc2626"
          className="upload-file-row__error-icon"
        />
      )}

      <button
        type="button"
        className="upload-file-row__remove"
        onClick={() => onRemove(file.id)}
        aria-label="Remove file"
      >
        <X size={13} />
      </button>
    </div>
  );
};

const FileList = ({ files, onRemove, onAddMore, showAddMore }) => {
  const errorCount = files.filter((f) => f.error).length;

  return (
    <div className="upload-filelist">
      <div className="upload-filelist__header">
        <span className="upload-filelist__count">
          {files.length} file{files.length !== 1 ? "s" : ""} selected
          {errorCount > 0 && (
            <span className="upload-filelist__error-count">
              · {errorCount} invalid
            </span>
          )}
        </span>
        {showAddMore && (
          <button
            type="button"
            className="upload-filelist__add-more"
            onClick={onAddMore}
          >
            + Add more
          </button>
        )}
      </div>

      <div className="upload-filelist__scroll">
        {files.map((f) => (
          <FileRow key={f.id} file={f} onRemove={onRemove} />
        ))}
      </div>
    </div>
  );
};

export default FileList;
